import { type RPPDomain } from 'utils/core/RPPCore.types'
import { fulfillmentTestingCenterAdminRouter } from 'domains/fulfillment-testing-center/routing/fulfillmentTestingCenterAdminRouter'
import { type DomainMessages } from 'domains/fulfillment-testing-center/utils/domain/intl'
import { routes } from 'domains/fulfillment-testing-center/routing/routes'
import EN_US from 'domains/fulfillment-testing-center/translations/en-US'
import { type DomainAccessControlConfig } from 'domains/fulfillment-testing-center/utils/domain/accessControl'
import { DevPortalNavEntryPoint } from 'gin-and-tonic/containers/nav/utils/devPortalNavConfig'

const definition: RPPDomain<typeof routes, DomainMessages, DomainAccessControlConfig> = {
  id: 'fulfillment-testing-center',
  routes,
  translations: { EN_US },
  routers: {
    devPortal: [fulfillmentTestingCenterAdminRouter],
  },
  navigationEntries: [],
  adminNavigationEntries: [],
  devPortalNavigationEntries: [
    {
      attachTo: DevPortalNavEntryPoint.FulfillmentTestingCenter,
      subNavItems: [
        {
          route: 'ftc-orders',
          labelId: 'fulfillmentTestingCenterDomain.title',
        },
      ],
    },
  ],
}

export default definition
